import { toPlainTextSync } from 'ricos-content/libs/toPlainTextSync';
const getVideoUrl = () => '';
const getVideoEmbeddedUrl = () => '';
const getAudioUrl = () => '';
const getGifUrl = () => '';
export function toPlainText(content) {
  return toPlainTextSync(content, {
    addLinksToText: false,
    getVideoUrl,
    getVideoEmbeddedUrl,
    getAudioUrl,
    getGifUrl
  });
}
export function isRichContent(data) {
  return typeof data === 'object' && data !== null && data.hasOwnProperty('nodes') && data.hasOwnProperty('metadata');
}
//# sourceMappingURL=rich-content.js.map